<div  class="container-fluid"><br>
  <div class="d-flex justify-content-between align-items-center">
    <h4>Action ({{detailsAction.length || 0}})</h4>
 
    <!-- Print Button -->
    <!-- <div class="dropdown d-inline-block " ngbDropdown>
      <button type="button" ngbDropdownToggle
          class="btn btn-primary dropdown-toggle" id="dropdownMenuButton" aria-haspopup="true"
          aria-expanded="false">
          Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>

      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu
          aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format
              PDF</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format
              Excel</a>
      </div>

  </div> -->
    <!-- <button type="button" class="btn btn-primary" >Imprimer</button> -->

    <button type="button" class="btn-close" (click)="close()"></button>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div>
        <div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light rwd-table">
                <tr>
                  <th>Code</th>
                  <th>Libelle</th>
                  <th>Poids</th>
                   <th style="white-space: nowrap;">TEP Prévisionnel</th>
                    <th style="white-space: nowrap;">TEP Réalisé</th>
                    <th>Ecart</th>
                  <th></th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of  paginatedItemsAction; let index = index">
                  <td>{{item?.action.code}}</td>
                  <td>{{item?.action.libelle}}</td>
                  <td>{{item?.action.poids_action}}</td>
                  <td>{{ item?.tep_prevu | number:'1.2-2' }}</td>
                  <td>{{ item?.tep_realise | number:'1.2-2' }}</td>
                   <td>{{ (item?.tep_realise - item?.tep_prevu) | number:'1.2-2' }}</td>
                                   
           
                  <td>
                    <a (click)="Consulter(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover
                      title="détails">
                      <i class="pi pi-eye font-size-18"></i>
                    </a>

                  </td>
                </tr>
              </tbody>
            </table>

            <div class="d-flex justify-content-center" *ngIf="isLoading === true">
              <div class="container">
                <div class="row">
                  <div class="text-center">
                    <h5 id="graycolor">Chargement en cours...</h5>
                    <div class="loader4"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div *ngIf="activiteOp.details.length === 0 && isLoading === false" class="d-flex justify-content-center">
              <div class="container">
                <div class="row">
                  <div class="text-center">
                    <h5 id="graycolor">Aucune donnée trouvée</h5>
                  </div>
                </div>
              </div>
            </div> -->
            <p-paginator (onPageChange)="onPageChangeAction($event)" [first]="firstaAction" [rows]="rowsAction"
              [totalRecords]="totalRecordsAction" [rowsPerPageOptions]="[10, 20, 30]">
            </p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #detailModal let-modal>
  <div style="border-color: rgb(51, 50, 50); border-style: double;" class="container-fluid"><br>
    <div class="d-flex justify-content-between align-items-center">
      <h4>Activités budgétaires</h4>

      <!-- Print Button -->
      <div class="dropdown d-inline-block " ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn btn-primary dropdown-toggle" id="dropdownMenuButton"
          aria-haspopup="true" aria-expanded="false">
          Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>

        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format
            PDF</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format
            Excel</a>
        </div>

      </div>
      <!-- <button type="button" class="btn btn-primary" >Imprimer</button> -->

      <button type="button" class="btn-close" (click)="modal.dismiss('Close click')"></button>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div>
          <div>
            <div class="table-responsive mt-3">
              <table class="table table-centered datatable dt-responsive nowrap"
                style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                <thead class="thead-light rwd-table">
                  <tr>
                    <th>Code</th>
                    <th>Activité</th>
                    <th>Poids</th>
                    <th>TEP Prévu</th>
                    <th>TEP Réalisé</th>
                    <th>Ecart</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of paginatedItems; let index = index">
                    <td>{{item?.activite.code_activite}}</td>
                    <td>{{item?.activite.activite}}</td>
                    <td>{{item?.activite.poids}}</td>
                    <td>{{item?.tep_prevu  | number:'1.2-2' }}</td>
                    <td>{{item.tep_realise | number:'1.2-2'}}</td>
                    <td>{{ (item.tep_realise - item.tep_prevu) | number:'1.2-2' }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                <div class="container">
                  <div class="row">
                    <div class="text-center">
                      <h5 id="graycolor">Chargement en cours...</h5>
                      <div class="loader4"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="detailsActivite.length === 0 && isLoading === false" class="d-flex justify-content-center">
                <div class="container">
                  <div class="row">
                    <div class="text-center">
                      <h5 id="graycolor">Aucune donnée trouvée</h5>
                    </div>
                  </div>
                </div>
              </div>
              <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
              [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
            </p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-toast />